import timg1 from '../images/team/img-1.jpg'
import timg2 from '../images/team/img-2.jpg'
import timg3 from '../images/team/img-3.jpg'
import timg4 from '../images/team/img-4.jpg'




import Stime1 from '../images/team/s1.jpg'
import Stime2 from '../images/team/s2.jpg'
import Stime3 from '../images/team/s3.jpg'
import Stime4 from '../images/team/s4.jpg'



const Teams = [
    {
        id: '1',
        title: 'Robert Fox',
        subtitle: 'HR Leader',
        slug: 'Henry-Bannet',
        timg: timg1,
        Sime: Stime1,
    },
    {
        id: '2',
        title: 'Kristin Watson',
        subtitle: 'Human Recources',
        slug: 'Tanean-Akrasen',
        timg: timg2,
        Sime: Stime2,
    },
    {
        id: '3',
        title: 'Guy Hawkins',
        subtitle: 'Manager',
        slug: 'Lily-Margerat',
        timg: timg3,
        Sime: Stime3,
    },
    {
        id: '4',
        title: 'Albert Flores',
        subtitle: 'Department Head',
        slug: 'William-Watson',
        timg: timg4,
        Sime: Stime4,
    },

]

export default Teams;



